import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import TroubleshootingService from 'services/TroubleshootingService'

export const initialState = {
    addError: {
        data: [],
        isLoading: false,
        error: false,
    },
    troubleshootingList: {
        data: [],
        isLoading: false,
        error: false,
    },
    troubleshootingDelete: {
        data: [],
        isLoading: false,
        error: false,
    },
    troubleshootingDetail: {
        data: [],
        isLoading: false,
        error: false,
    },
    troubleshootingEdit: {
        data: [],
        isLoading: false,
        error: false,
    },
}

export const addError = createAsyncThunk('troubleshooting/addError', async (data, { rejectWithValue }) => {
    try {
        const response = await TroubleshootingService.addError(data)
        return response
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const fetchTroubleshootingList = createAsyncThunk(
    'troubleshooting/getTroubleshootings',
    async (data, { rejectWithValue }) => {
        try {
            console.log(data)
            const response = await TroubleshootingService.getErrorListDynamic(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const deleteTroubleshooting = createAsyncThunk(
    'troubleshooting/deleteTroubleshooting',
    async (params, { rejectWithValue }) => {
        try {
            await TroubleshootingService.deleteTroubleshooting(params)
            return params
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const deleteTroubleshootingAttachment = createAsyncThunk(
    'troubleshooting/deleteTroubleshootingAttachment',
    async (params, { rejectWithValue }) => {
        try {
            await TroubleshootingService.deleteTroubleshootingAttachment(params)
            return params
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const fetchTroubleshootingDetail = createAsyncThunk(
    'troubleshooting/getTroubleshootingDetail',
    async (params, { rejectWithValue }) => {
        try {
            const response = await TroubleshootingService.getTroubleshootingDetail(params)
            return response.data
        } catch (err) {
            console.log(err)
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const updateTroubleshooting = createAsyncThunk(
    'troubleshooting/updateTroubleshooting',
    async (data, { rejectWithValue }) => {
        try {
            const response = await TroubleshootingService.updateTroubleshooting(data)
            return response
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

const troubleshootingSlice = createSlice({
    name: 'troubleshooting',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addError.pending, (state) => {
                state.addError.isLoading = true
            })
            .addCase(addError.rejected, (state, action) => {
                state.addError.isLoading = false
                state.addError.error = action.payload
            })
            .addCase(addError.fulfilled, (state, action) => {
                state.addError.isLoading = false
                state.addError.error = false
                state.addError.data = action.payload
            })

            .addCase(fetchTroubleshootingList.pending, (state, action) => {
                state.troubleshootingList.isLoading = true
            })
            .addCase(fetchTroubleshootingList.rejected, (state, action) => {
                state.troubleshootingList.isLoading = false
                state.troubleshootingList.error = action.error.message
            })
            .addCase(fetchTroubleshootingList.fulfilled, (state, action) => {
                state.troubleshootingList.isLoading = false
                state.troubleshootingList.error = false
                state.troubleshootingList.data = action.payload
            })

            .addCase(fetchTroubleshootingDetail.pending, (state, action) => {
                state.troubleshootingDetail.isLoading = true
            })
            .addCase(fetchTroubleshootingDetail.rejected, (state, action) => {
                state.troubleshootingDetail.error = action.error.message
            })
            .addCase(fetchTroubleshootingDetail.fulfilled, (state, action) => {
                state.troubleshootingDetail.isLoading = false
                state.troubleshootingDetail.error = false
                state.troubleshootingDetail.data = action.payload
               
            })

            // Update Record
            .addCase(updateTroubleshooting.pending, (state, action) => {
                state.troubleshootingEdit.isLoading = true
            })
            .addCase(updateTroubleshooting.rejected, (state, action) => {
                state.troubleshootingEdit.isLoading = false
                state.troubleshootingEdit.error = action.error.message
            })
            .addCase(updateTroubleshooting.fulfilled, (state, action) => {
                state.troubleshootingEdit.isLoading = false
                state.troubleshootingEdit.error = false
                state.troubleshootingEdit.success = true
            })
    },
})

export default troubleshootingSlice.reducer
